import React from "react";
import "./Services.css";

import iconPregnancyPlanning from "../assets/service1.svg";
import iconUrologyConsultation from "../assets/service2.svg";
import iconLabDiagnostics from "../assets/service3.svg";
import iconGynecology from "../assets/service4.svg";
import iconEggDonation from "../assets/service5.svg";
import iconCryopreservation from "../assets/service6.svg";
import iconGeneticDiagnostics from "../assets/service7.svg";
import iconInsemination from "../assets/service8.svg";

import carousel1 from "../assets/slide1.png";
import carousel3 from "../assets/slide2.png";
import carousel2 from "../assets/slide3.png";
import Carousel from "./Carousel";
import { useTranslation } from "react-i18next";

const Services = () => {
	const { t } = useTranslation();

	const services = [
		{
			icon: iconCryopreservation,
			title: t("ServTitleCar1"),
		},
		{ icon: iconEggDonation, title: t("ServTitleCar2") },
		{ icon: iconGeneticDiagnostics, title: t("ServTitleCar3") },
		{ icon: iconGynecology, title: t("ServTitleCar4") },
		{ icon: iconInsemination, title: t("ServTitleCar5") },
		{ icon: iconLabDiagnostics, title: t("ServTitleCar6") },
		{ icon: iconPregnancyPlanning, title: t("ServTitleCar7") },
		{ icon: iconUrologyConsultation, title: t("ServTitleCar8") },
	];

	const carouselItems = [
		{
			image: carousel1,
			title: t("ServCarTitle1"),
			description: t("ServCarText1"),
		},
		{
			image: carousel2,
			title: t("ServCarTitle2"),
			description: t("ServCarText2"),
		},
		{
			image: carousel3,
			title: t("ServCarTitle3"),
			description: t("ServCarText3"),
		},
	];

	return (
		<div className="services">
			<div className="services-header">
				<h2>{t("ServHead")}</h2>
				<p>{t("ServDesc")}</p>
			</div>

			<div className="services-grid">
				{services.map((service, index) => (
					<div key={index} className="service-card">
						<img
							src={service.icon}
							alt={`${service.title} Icon`}
							className="service-icon"
						/>
						<h3>{service.title}</h3>
					</div>
				))}
			</div>

			<Carousel items={carouselItems} />
		</div>
	);
};

export default Services;
